module.exports = __webpack_public_path__ + "static/media/filled-circle.c61eaf52.svg";